import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import dayjs from 'dayjs';
import XHR from 'i18next-xhr-backend'; // have a own xhr fallback
import { Configuration } from "puzzle";



const { BASE_ROUTE_NAME: APP_SUBDIRECTORY, I18N_HASH } = Configuration.get();
let BACKEND_LOAD_PATH = process.env.i18n.separateTranslationPerNamespaces ? '/locales/{{ns}}/{{lng}}.json' : '/locales/{{lng}}.json';
BACKEND_LOAD_PATH += `?dc=${I18N_HASH}`;
const subDirectory = APP_SUBDIRECTORY;
if (subDirectory.length) {
  BACKEND_LOAD_PATH = subDirectory + BACKEND_LOAD_PATH;
}



const DEV_MODE = process.env.NODE_ENV === 'development';
const defaultLocale = 'en-US';

const stylesAppliedToLocalisation = ['font-weight', 'color']; // styles applied in order
const styleAppliedSeparator = ':';

/**
 * Format text based on style.
 * @param text Localised text value.
 * @param styleValue Values to pre format passed text.
 * @returns {string}
 */
const formatText = (text, styleValue = '') => {
  const styleValues = styleValue.split(styleAppliedSeparator);
  text = stylesAppliedToLocalisation.reduce((value, style, index) => {
    if (value.match(style)) {
      value = value.replace(`${style}:inherit`, `${style}:${styleValues[index] || 'inherit'}`);
    }
    return value;
  }, text);

  return text;
};

let options = {
  ns: ['translation', 'common'],
  cleanCode: true, //language will be lowercased EN --> en while leaving full locales like en-US
  lng: defaultLocale,
  fallbackLng: defaultLocale,
  keySeparator: '.', // don't use keys in form `message.welcome`
  returnObjects: true,
  interpolation: {
    nestingPrefix: '[[',
    nestingSuffix: ']]',
    escapeValue: false, // react already safes from xss
    format: function (value, format, lng) {
      // to uppercase 
      if (format === 'uppercase') return value.toUpperCase();

      // to date format
      if (value instanceof Date) {
        return dayjs(value).format(format);
      }

      // to font style format {{sFontFormat, bolder:#50ef14}} ... some text ... {{eFontStyle}}
      const formatted = formatText(value, format);
      if (formatted) {
        return formatted;
      }

      return value;
    }
  },
  react: {
    useSuspense: false,
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    wait: true,
    bindI18n: 'initialized languageChanged loaded',
    bindI18nStore: 'initialized languageChanged loaded',
  },
  load: 'currentOnly',
  partialBundledLanguages: false, //allows some resources to be set on initialization while others can be loaded using a backend connector
  preload: [defaultLocale]
};



Object.assign(options, DEV_MODE ? {
  
} : {
  backend: {
    loadPath: BACKEND_LOAD_PATH,
    allowMultiLoading: true // required by backend loader to load multiple files on demand
  }
});

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(DEV_MODE ? {} : XHR)
  .init(options);



export default i18n;
